module.exports = __webpack_public_path__ + "media/images/img-secondcarrier-9-dd9ff39f.png";